<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
    <side-drawer></side-drawer>
    </v-navigation-drawer>

    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Markup Help</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex>
            <v-container  fluid grid-list-xl >
              <v-layout justify-start row wrap>
                <v-flex>
                  <h2  class="subheading font-weight-medium">
                      Markups are an efficient way to predefine the Price box of a product based on its original cost price. Once a markup is defined, it can be used multiple times over various product creations.
                  </h2>
                </v-flex>
              </v-layout>
            </v-container>

            <v-layout class="mb-1">
              <v-flex>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Markup page walkthrough</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                        <v-layout justify-start row wrap>
                          <v-flex>
                            <h2 class="subheading font-weight-medium">For this walkthrough, the markup below has been chosen:</h2>
                            <div class="mb-5 mt-2">
                              <img src="/static/img/help/markup/walkthrough/MarkupChosenForWalthrough.jpg" style="max-width:80%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout class="mb-5" justify-start row wrap>
                          <v-flex>
                            <h1  class="title font-weight-medium">Top Section</h1>
                          </v-flex>
                          <v-flex class="pl-5">
                            <h2 class="subheading font-weight-medium">At the very top is the Markup name and Markup ID.</h2>
                            <div class="mb-3 mt-2">
                              <img src="/static/img/help/markup/walkthrough/MarkupTopSection.jpg" style="max-width:80%;" />
                            </div>
                            <h2 class="subheading font-weight-medium">Just below the Markup name is the Currency. You have the option to choose between RMB and USD.</h2>
                            <div class="mt-2">
                              <img src="/static/img/help/markup/walkthrough/MarkupCurrencyField.jpg" style="max-width:80%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout class="mb-5" justify-start row wrap>
                          <v-flex>
                            <h1  class="title font-weight-medium">Range</h1>
                          </v-flex>
                          <v-flex class="pl-5">
                            <div class="">
                              <img src="/static/img/help/markup/walkthrough/MarkupRange.jpg" style="max-width:80%;" />
                            </div>
                            <h2 class=" mt-2 subheading font-weight-medium">The numbers in the black boxes represent the price range which the markup falls within. In the above example, the ranges are 70, 210, and others. This means that any products within the price range of 1 - 70 are in one range, 71 - 210 are in one range and anything above that would be in the ‘others’ range.</h2>
                            <h2 class=" mt-2 subheading font-weight-medium">To add another range simply click on the '+' button.</h2>
                          </v-flex>
                        </v-layout>
                        <v-layout class="mb-5" justify-start row wrap>
                          <v-flex>
                            <h1  class="title font-weight-medium">View Products in Range</h1>
                          </v-flex>
                          <v-flex class="pl-5">
                            <div class="">
                              <img src="/static/img/help/markup/walkthrough/MarkupRangeLinksCircled.jpg" style="max-width:80%;" />
                            </div>
                            <h2 class=" subheading font-weight-medium">You have the option of viewing the products that fall in the price range by clicking on the link below the ranges.</h2>
                            <h2 class=" subheading font-weight-medium">The Recount button is simply to refresh the count for the products that fall within the range in case any new products have been added.</h2>
                          </v-flex>
                        </v-layout>
                        <v-layout class="mb-5" justify-start row wrap>
                          <v-flex>
                            <h1  class="title font-weight-medium">Markup Table</h1>
                          </v-flex>
                          <v-flex class="pl-5">
                            <div class="mb-3">
                              <img src="/static/img/help/markup/walkthrough/MarkupTable.jpg" style="max-width:80%;" />
                            </div>
                            <h2 class="mt-2 mb-2 subheading font-weight-medium">At first glance it may seem confusing. However it is simply markup ranges put side by side.</h2>
                            <div class="">
                              <img src="/static/img/help/markup/walkthrough/HighlightRangeSidebySide.jpg" style="max-width:80%;" />
                            </div>
                          </v-flex>
                          <v-flex class="pl-5">
                            <h2 class="mt-2 mb-2 subheading font-weight-medium">In order to break it down even further, there are 4 types of columns on this table:</h2>
                            <h3  class="subheading font-weight-bold">Quantity</h3>
                            <h3 class="subheading ">The first column represents the quantity of products required for the markup to be in effect.</h3>
                            <div class="">
                              <img src="/static/img/help/markup/walkthrough/HighlightQuantity.jpg" style="max-width:80%;" />
                            </div>
                            <h3 class="subheading mb-4 ">
                              The way the quantity range works is any quantity that falls within the current number until just before the next number up gets applied the markup percentage. So in the above example, any quantity from the range of 1(current number) - 2(before the next number up) would have the first row applied , any quantity from the range of 3 - 4 would have the second row applied and etc.
                            </h3>

                            <h3  class="subheading font-weight-bold">Markup percentage</h3>
                            <div class="">
                              <img src="/static/img/help/markup/walkthrough/HighlightMarkupPercentage.jpg" style="max-width:80%;" />
                            </div>
                            <h3 class="subheading mb-4">
                              The markup percentage is increasing the cost price of the product by the percentage. In the product creation or editing section, there is a field called the Cost Price. That is the number which these markup percentages are applied to.
                            </h3>

                            <h3  class="subheading font-weight-bold">Minimum Markup</h3>
                            <div class="">
                              <img src="/static/img/help/markup/walkthrough/HighlightMinimumMarkup.jpg" style="max-width:80%;" />
                            </div>
                            <h3 class="subheading mb-4">
                              The minimum markup just specifies how much the price has to increase by regardless of the outcome of the calculation for the markup percentage. In other words, the price increase has to be at least the number specified in the column. Let’s take the first row first markup as an example. If by chance the outcome of the calculation is less than 3, then 3 would be used as the markup price.
                            </h3>

                            <h3  class="subheading font-weight-bold">Wholesale</h3>
                            <div class="">
                              <img src="/static/img/help/markup/walkthrough/HighlightWholesale.jpg" style="max-width:80%;" />
                            </div>
                            <h3 class="subheading mb-3">
                              The wholesale column is for the wholesale members. The wholesale row , when checked, means that regardless of the quantity the wholesale members would have the markup percentage applied to the product. So in the above example, the last row is checked. This means that for any quantity bought by the wholesale member, it would either be 25%, 20% or 0%  markup percentage depending on the price range.
                            </h3>
                          </v-flex>
                        </v-layout>
                        <v-layout class="mb-4" justify-start row wrap>
                          <v-flex>
                            <h1  class="title font-weight-medium">Insert Section</h1>
                          </v-flex>
                          <v-flex class="pl-5">
                            <div class="mb-2 mt-2">
                              <img src="/static/img/help/markup/walkthrough/InsertSection.jpg" style="max-width:60%;" />
                            </div>
                            <h2 class="subheading font-weight-medium">Finally the very bottom section are for inserting a new markup row and price range. The ‘+’ sign and INSERT QTY both allows you to insert a markup row. The difference being, the ‘+’ sign inserts a new one right at the bottom with an incremented quantity whereas the INSERT QTY allows you to choose which row to insert it into.</h2>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

            <!------------- Use Markup ------------>
            <v-layout class="mb-1">
              <v-flex>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Use Markup</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                          <v-layout style="margin-bottom:10px" justify-start row wrap>
                          <v-flex>
                            <h2  class="subheading font-weight-medium">
                                In order to use a markup, navigate to the product edit/creation page. Near the bottom of the page there’s a field called Markup where you can choose the markup you wish.
                            </h2>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/markup/use/MarkupField.jpg" style="max-width:70%;" />
                            </div>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/markup/use/MarkupSelection.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

            <!------------- Create Markup ------------>
            <v-layout class="mb-1">
              <v-flex>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Create Markup</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              1
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Go to the Manage Markup section
                            </h3>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              2
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Click on the ‘+’ sign located at the bottom right
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/markup/create/Click+ToAddMarkup.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              3
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Enter a name you like and click ADD
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/markup/create/ClickAdd.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              4
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Look for the name of the markup you created and click it.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/markup/create/FindMarkup.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

            <!------------- Delete Markup ------------>
            <v-layout class="mb-1">
              <v-flex>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Delete Markup</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              1
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/markup/delete/clickDots.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              2
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/markup/delete/clickDelete.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              3
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/markup/delete/delete.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

  </div>
</template>

<script>

import SideDrawer from '@/components/SideDrawer.vue'

export default {
  data () {
    return {
      drawer: false
    }
  },
  components: {
    SideDrawer
  },
  mounted () {
    this.openDrawerForDesktop()
  }
}
</script>

<style scoped>

.round-number {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: #ff0000;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  padding-top: 3px;
}

</style>
